import { useSelector } from '../redux/store';
import { useModules } from '../contexts/ModuleContext';
import { selectedRoles, modulesForOtherRoles } from '../roles/roleBasedModules';
import navConfig from '../layouts/dashboard/navbar/NavConfig';
import { getSuperAdminNavItems } from '../layouts/dashboard/navbar/superAdminNavConfig';
import { PATH_DASHBOARD } from '../routes/paths';
import { ADMIN_ROLE_SUPER } from '../constants/moduleAccess';

function filterSidebarByCompanyModules(items, canAccessAppModule) {
  return items
    .filter((item) => !item.modulePath || canAccessAppModule(item.modulePath))
    .map((item) => {
      if (item.modulePath === 'settings' && item.children?.length) {
        return {
          ...item,
          children: item.children.filter(
            (child) => child.path !== PATH_DASHBOARD.settings.scanAttemptLimit || canAccessAppModule('campaign')
          ),
        };
      }
      return item;
    });
}

const useManageSidebar = () => {
  const { sidebarContent } = useSelector((state) => state.invoiceSlice);
  const { canAccessAppModule, isCompanyAdmin, loading } = useModules();

  const prepareArray = sidebarContent.map((item) => ({
    title: item,
    path: `/admin/invoice/${item}`,
  }));
  const modifiedContent = navConfig[0]?.items?.map((item) => {
    if (item.title === 'Invoice') {
      return {
        ...item,
        children: prepareArray,
      };
    }
    return item;
  });

  const getuser = JSON.parse(localStorage.getItem('admin') || '{}');
  let collectSidebarContentAsPerRole;

  if (getuser?.role === ADMIN_ROLE_SUPER) {
    collectSidebarContentAsPerRole = [...getSuperAdminNavItems()];
  } else if (selectedRoles.includes(getuser && getuser?.designation?.toUpperCase())) {
    collectSidebarContentAsPerRole = modifiedContent;
  } else {
    collectSidebarContentAsPerRole = modulesForOtherRoles.reduce((acc, item) => {
      const foundModule = modifiedContent.find((menu) => item.name === menu.title);
      if (foundModule) acc.push(foundModule);
      return acc;
    }, []);
  }

  if (isCompanyAdmin && !loading) {
    collectSidebarContentAsPerRole = filterSidebarByCompanyModules(collectSidebarContentAsPerRole, canAccessAppModule);
  }

  return { collectSidebarContentAsPerRole };
};
export default useManageSidebar;
